
import React, { Fragment } from 'react';

// Components

import EmployerCoverageDetails from './EmployerCoverageDetails';
import SummaryFilter from '../SummaryFilter';
import SummaryItem from '../SummaryItem';

// Types

import { SsapSummaryType } from '@components/ssap/SsapTypes';



const EmployerCoverageInfo = props => {
    
    const {
        applicantGuid,
        employerSponsoredCoverage,
        healthCoverage: {
            employerWillOfferInsuranceIndicator
        },
        householdMembers,
        idx,
        isEmployerCoverageShown,
        previousData,
        isState,
        isFinalSummaryPage,
        isSsapInReviewMode
    } = props;
    
    if (!isEmployerCoverageShown) {
        return null;
    }
    
    return (
        <Fragment>
            <div className = 'grid-col-12' >
                <div className = 'grid-row' >
                    <SummaryItem
                        category = 'ssap.additional_info.summary.offered_employer_coverage'
                        value = { employerWillOfferInsuranceIndicator }
                        noPriorDataValues = { [ null ] }
                        desc = {
                            [
                                [
                                    `taxHousehold.householdMember[${ idx }].healthCoverage.employerWillOfferInsuranceIndicator`
                                ]
                            ]
                        }
                    />
                </div>
            </div>
            
            {
                employerWillOfferInsuranceIndicator &&

                <SummaryFilter summaryId = { SsapSummaryType.EMPLOYER_COVERAGE_DETAILS }>
                    <EmployerCoverageDetails
                        { ...{
                            applicantGuid,
                            employerSponsoredCoverage,
                            householdMembers,
                            idx,
                            previousData,
                            isState,
                            isFinalSummaryPage,
                            isSsapInReviewMode
                        } }
                    />
                </SummaryFilter>
            }
        </Fragment>
    );
};

export default EmployerCoverageInfo;